import { useData } from '@app/data/repositories';
import { CaseDetailScreen } from './CaseDetailScreen';
import { useCaseDetail } from './useCaseDetail';

/** Вход карточки дела: данные и навигация здесь, экран о них не знает. */
export function CaseDetailRoute({
  caseId,
  onBack,
  onOpenDocuments,
  onOpenDocument,
  onOpenClient,
  onOpenEvent,
}: {
  caseId: string;
  onBack: () => void;
  onOpenDocuments: () => void;
  onOpenDocument: (id: string) => void;
  onOpenClient: (id: string) => void;
  onOpenEvent: (id: string) => void;
}) {
  const { db } = useData();
  const { state, actions } = useCaseDetail(db, caseId);

  return (
    <CaseDetailScreen
      state={state}
      actions={actions}
      onBack={onBack}
      onOpenDocuments={onOpenDocuments}
      onOpenDocument={onOpenDocument}
      onOpenClient={onOpenClient}
      onOpenEvent={onOpenEvent}
    />
  );
}
